import { render } from "./Advice1.vue?vue&type=template&id=69e5a066&scoped=true"
import script from "./Advice1.vue?vue&type=script&lang=js"
export * from "./Advice1.vue?vue&type=script&lang=js"

import "./Advice1.vue?vue&type=style&index=0&id=69e5a066&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69e5a066"]])

export default __exports__